import React from "react";
import { Section, sectionSpacingY } from "components/section";
import { Box, SimpleGrid } from "@chakra-ui/react";
import { useCdpIndustry } from "contexts/cdp-industry-context";
import { TextTitle } from "ui/text";
import { DirectionalButton } from "ui/button";

export function CdpIndustryPersonalizationLeadersCards() {
  const { industry } = useCdpIndustry();

  return (
    <Section my="0" pt={sectionSpacingY}>
      <TextTitle
        size="lg"
        align="center"
        title={`Industry leaders in ${
          industry.abbreviatedName ?? industry.name
        } differentiate themselves with personalization`}
      />

      <SimpleGrid
        columns={{ base: 1, lg: 3 }}
        gap={{ base: "bigger", lg: "small" }}
        mt={{ base: "biggest", md: "huge" }}
        justifyItems={{ base: "center", lg: "stretch" }}
      >
        {industry.personalizationCards.map((card) => {
          const isInternalLink = card.href.startsWith("/");
          return (
            <Box key={card.title} bg="brand.backgroundSecondary.light" borderRadius="base" padding="big" maxW="385px">
              <TextTitle
                size="xs"
                titleAs="h3"
                title={card.title}
                actions={
                  <DirectionalButton
                    variant="tertiary"
                    href={card.href}
                    // Use new tab/noreferrer for external links
                    target={isInternalLink ? "_self" : "_blank"}
                    rel={isInternalLink ? undefined : "noreferrer"}
                    pl="0"
                  >
                    Learn more
                  </DirectionalButton>
                }
                boxSize="100%"
              />
            </Box>
          );
        })}
      </SimpleGrid>
    </Section>
  );
}
